import React from "react";

const Life = () => {
  return (
    <div className="w-full h-screen">
      <iframe
  src="https://nk.lifecommando.in/widget/form/TJ59mCjLRc91gdQk0TAg"
  style={{ width: "100%", height: "100%", border: "none",borderRadius: "3px" }}
  id="inline-TJ59mCjLRc91gdQk0TAg" 
  data-layout="{'id':'INLINE'}"
  data-trigger-type="alwaysShow"
  data-trigger-value=""
  data-activation-type="alwaysActivated"
  data-activation-value=""
  data-deactivation-type="neverDeactivate"
  data-deactivation-value=""
  data-form-name="Life Membership  Member Details "
  data-height="3633"
  data-layout-iframe-id="inline-TJ59mCjLRc91gdQk0TAg"
  data-form-id="TJ59mCjLRc91gdQk0TAg"
  title="Life Membership  Member Details "
      >
</iframe>
<script src="https://nk.lifecommando.in/js/form_embed.js"></script>
    </div>
  );
};

export default Life;
